import { httpClient } from '../../../../Common/api/http_client';

/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function fetchAllAttributesGroups() {
  return httpClient.get('/group');
}

/**
 *
 * @param data
 * @returns {Promise<AxiosResponse<T>>}
 */
export function createAttributesGroups(data) {
  return httpClient.post('/group', data);
}

/**
 *
 * @param data
 * @param groupId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateAttributeGroups(data, groupId) {
  return httpClient.put(`/group/${groupId}`, data);
}

/**
 *
 * @param groupId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteAttributeGroups(groupId) {
  return httpClient.delete(`/group/${groupId}`);
}

/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function fetchAllAttributes() {
  return httpClient.get('/merchant/attributes');
}

/**
 *
 * @param data
 * @returns {Promise<AxiosResponse<T>>}
 */
export function createAttributes(data) {
  return httpClient.post('/merchant/attributes', data);
}

/**
 *
 * @param data
 * @param attributeId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateAttribute(data, attributeId) {
  return httpClient.put(`/merchant/attributes/${attributeId}`, data);
}

/**
 *
 * @param attributeId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteAttribute(attributeId) {
  return httpClient.delete(`/merchant/attributes//${attributeId}`);
}

/**
 *
 * @param groupId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function fetchAttributesByGroups(groupId) {
  return httpClient.get(`/merchant/groups/${groupId}/attributes`);
}
